var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.895 1.047 4.703 8.238 2.078 5.586c-.137-.11-.355-.11-.465 0l-.793.793c-.11.11-.11.328 0 .465l3.664 3.636a.315.315 0 0 0 .465 0l8.203-8.203c.11-.109.11-.328 0-.465l-.793-.765c-.109-.137-.328-.137-.464 0z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirm);
export default __webpack_public_path__ + "static/media/icon-confirm.dffed2f46da2a04e3b32040c8f2441a2.svg";
export { ForwardRef as ReactComponent };